import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, Observable, switchMap, throwError } from "rxjs";
import {
  ANONYMOUS_REQUEST,
  AuthService,
  DISABLE_ORG_SWITCHING,
} from "../pages/auth/services/auth.service";
import { addToken } from "./jwt.interceptor";
import { AuthStore } from "../pages/auth/store/auth.store";
import { environment } from "../../environments/environment";

export function refreshTokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const authStore = inject(AuthStore);

  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status == 401) {
        if (
          req.context.get(ANONYMOUS_REQUEST) ||
          !req.url.startsWith(environment.baseUrl)
        ) {
          return throwError(() => error);
        }

        const hadAccessToken = !!authStore.accessToken();

        return authService.getToken(true).pipe(
          catchError((err) => {
            if (hadAccessToken) {
              authStore.logout({ data: "Session Expired forcing logout" });
            }
            return throwError(() => err);
          }),
          switchMap((token) => {
            const accessToken = token?.tokens?.accessToken.toString() ?? "";
            if (!accessToken) {
              if (hadAccessToken) {
                authStore.logout({ data: "Session Expired forcing logout" });
              }
              return throwError(() => error);
            }

            const disableOrgSwitching = req.context.get(DISABLE_ORG_SWITCHING);

            authStore.setToken(accessToken);
            return next(addToken(req, accessToken, disableOrgSwitching));
          }),
        );
      }

      return throwError(() => error);
    }),
  );
}
